<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
  color: #000000;
  background-color: #fff;
}
</style>